import React, { useEffect, useState } from 'react';
import styles from './scss/clvanalysis.module.scss';
import ApexBarChart from '../../components/custom_components/apexChartsTypes/barChart';
import ApexLineChart from '../../components/custom_components/apexChartsTypes/lineChart';
import { clvSummaryNlpData } from '../../apiservice/aiPilot';
import moment from 'moment';
import { dashboardAction } from '../../store/slices/dashboard';
import { useDispatcher } from '../../custom_hooks/use_app_dispatch';
import Loaders from '../../components/loader/loader';
import { useSelector } from 'react-redux';
import WorktualModal from '../../components/custom_components/worktualModal';
import DonutChart from '../../components/custom_components/apexChartsTypes/donutChart';
import { clvSummaryNlpLycaData, getLycaCountEachChannelCategory, getLycaDistributionCvlSegement, getLycaDistributionNboSegement, getLycaDistributionRfm, getLycaMothwiseTotalBundleCost, getLycaPercentageContribution, getLycaRevenueCostSims, getLycaTotalRevenuePerCustomer, getLycaTotalRevenueRechargeTyp, getLycaUserCountSim } from '../../apiservice/aiLycaPilot';
import dayjs from "dayjs";

const ClvAnalysisLyca = () => {
    interface SeriesData {
        name: string;
        data: number[];
    }
    const [loader, setLoader] = useState(false)
    const [lineChartHourData, setLineChartHourData] = useState<any>([]);
    const [lineChartAmountData, setLineChartAmountData] = useState<any>([]);
    const [lineChartBundleAmount, setLineChartBundleAmount] = useState<any>([]);
    const [categories1, setCategories1] = useState<string[]>([]);
    const [categories2, setCategories2] = useState<string[]>([]);
    const [categories3, setCategories3] = useState<string[]>([]);
    const [categories4, setCategories4] = useState<string[]>([]);
    const [clvCategories, setClvCategories] = useState<string[]>([]); // X-axis labels (hours 0–23)
    const [lineChartBundleHrs, setLineChartBundleHrs] = useState<any[]>([]); // Series data
    const [categoriesNbo, setCategoriesNbo] = useState<string[]>([]); // X-axis labels (hours 0–23)
    const [seriesNbo, setSeriesNbo] = useState<any[]>([]); // Series data
    const [categoriesRevenue, setCategoriesRevenue] = useState<string[]>([]);
    const [seriesRevenue, setSeriesRevenue] = useState<any[]>([]);

    const [seriesbar, setSeriesBar] = useState<SeriesData[]>([]);
    const [seriesbarWeekDay, setSeriesBarWeekDay] = useState<SeriesData[]>([]);
    const [categories, setCategories] = useState<string[]>([]);
    const [categoriesweekday, setCategoriesweekday] = useState<string[]>([]);
    const [categoriesBundleData, setCategoriesBundleData] = useState<string[]>([]);
    const [seriesbarBundleData, setSeriesBundleData] = useState<SeriesData[]>([]);
    const [seriesBubleWeek, setSeriesBubleWeek] = useState<SeriesData[]>([]);
    const [categoriesBubleWeek, setCategoriesBubleWeek] = useState<string[]>([]);
    const [nlpData, setNlpData] = useState<any>(null);
    const dispatch = useDispatcher()
    const year = 2022;
    const from = moment().year(year).startOf('year').format('YYYY-MM-DD');
    const currentDate = moment().year(2025).format('YYYY-MM-DD'); // asume 2019 
    const [startDate, setStartDate] = useState(from);
    const [endDate, setEndDate] = useState(currentDate);
    const { clvNlpData, nlpSummary, clvNlpLycaData } = useSelector((store: any) => store.dashboardReducer)
    const [showInsightsModal, setShowInsightsModal] = useState(false);
    const [donutSeries, setDonutSeries] = useState<number[]>([0, 0, 0]);
    const [donutLabels, setDonutLabels] = useState<string[]>([]);

    console.log('nlpSummary---------', clvNlpLycaData)

    useEffect(() => {
        const fetchNlpData = async () => {
            try {
                setLoader(true);

                const res = await clvSummaryNlpLycaData();
                console.log('clvSummaryNlpLycaData=====', res)
                if (res?.status === 200) {
                    setNlpData(res.data.message); // store API result
                    dispatch(dashboardAction.setClvNlpLycaData(res.data.message))
                }
            } catch (error) {
                console.error("Error fetching NLP data:", error);
            } finally {
                setLoader(false);
            }
        };
        fetchNlpData();
    }, []);

    useEffect(() => {
        callApis(startDate, endDate)
    }, [startDate, endDate])

    const callApis = (startDate: any, endDate: any) => {
        if (!startDate || !endDate) return
        const body = {
            domainId: null,
            fromYear: moment(startDate).format('YYYY-MM-DD'),
            toYear: moment(endDate).format('YYYY-MM-DD'),
        }
        getLycaUserCountSimData(body)
        getLycaRevenueCostSimsData(body)
        getLycaTotalRevenueRechargeTypData(body)
        getLycaMothwiseTotalBundleCostData(body)
        getLycaPercentageContributionData(body)
        getLycaDistributionRfmData(body)
        getLycaCountEachChannelCategoryData(body)
        getLycaDistributionCvlSegementData(body)
        getLycaDistributionNboSegementData(body)
        getLycaTotalRevenuePerCustomerData(body)
        dispatch(dashboardAction.setModuledateFilter(body))
    }

    const getLycaUserCountSimData = async (body: any) => {
        try {
            setLoader(true);

            const res = await getLycaUserCountSim(body);

            if (res?.data?.statusCode === 200) {
                let x: any[] = res?.data?.response ?? [];
                console.log("x------------", x);

                if (x.length > 0) {
                    // Extract SIM_TYPE as categories and user_count as values
                    const categories = x.map((item) => item.SIM_TYPE);
                    const data = x.map((item) => item.user_count ?? 0);

                    setSeriesBar([
                        {
                            name: "User Count",
                            data,
                        },
                    ]);
                    setCategories(categories);
                } else {
                    // If no data, reset chart
                    setSeriesBar([]);
                    setCategories([]);
                }
            }
        } catch (error) {
            console.error("Error fetching Lyca User Count Sim:", error);
        } finally {
            setLoader(false);
        }
    };



    const getLycaRevenueCostSimsData = async (body: any) => {
        try {
            const res = await getLycaRevenueCostSims(body);

            if (res?.data?.statusCode === 200) {
                const x: { SIM_TYPE: string; user_count: number }[] = res.data.response;

                if (x?.length > 0) {
                    // Categories are SIM_TYPE, values are user_count
                    const categories = x.map(item => item.SIM_TYPE);
                    const data = x.map(item => item.user_count ?? 0);

                    setSeriesBarWeekDay([
                        {
                            name: "Total Bundle Cost",
                            data
                        }
                    ]);

                    setCategoriesweekday(categories);
                } else {
                    setSeriesBarWeekDay([]);
                    setCategoriesweekday([]);
                }
            }
        } catch (error) {
            console.error("Error fetching Lyca Revenue Cost Sims:", error);
        }
    };

    const getLycaTotalRevenueRechargeTypData = async (body: any) => {
        try {
            const res = await getLycaTotalRevenueRechargeTyp(body);

            if (res?.data?.statusCode === 200) {
                const response: { recharge_name: string; revenue: number }[] =
                    res.data.response;

                if (response?.length > 0) {
                    // ✅ use recharge_name for x/y axis labels
                    const categories = response.map((item) => item.recharge_name);
                    const data = response.map((item) => item.revenue ?? 0);

                    setLineChartHourData([
                        {
                            name: "Total Revenue",
                            data,
                        },
                    ]);

                    setCategories1(categories);
                } else {
                    setLineChartHourData([]);
                    setCategories1([]);
                }
            }
        } catch (error) {
            console.error("Error fetching Total Revenue by Recharge Type:", error);
        }
    };

    const getLycaMothwiseTotalBundleCostData = async (body: any) => {
        try {
            const res = await getLycaMothwiseTotalBundleCost(body);

            if (res?.data?.statusCode === 200) {
                const response: { SIM_TYPE: string; Month: number; Actual_Bundle_Cost: number }[] =
                    res.data.response;

                if (response?.length > 0) {
                    // Extract unique months sorted
                    const months = Array.from(new Set(response.map(item => item.Month))).sort(
                        (a, b) => a - b
                    );
                    console.log("months---", months);

                    // Extract unique SIM types
                    const simTypes = Array.from(new Set(response.map(item => item.SIM_TYPE)));

                    // Build ApexCharts series (one for each SIM_TYPE)
                    const series = simTypes.map(sim => ({
                        name: sim,
                        data: months.map(month => {
                            const record = response.find(
                                item => item.SIM_TYPE === sim && item.Month === month
                            );
                            return record ? record.Actual_Bundle_Cost : 0;
                        }),
                    }));
                    // Determine year (from body or current year)
                    const year = body?.Year ?? dayjs().year();

                    // ✅ Format categories as Jan25, Feb25, ...
                    const categories = months.map(m =>
                        dayjs(`${year}-${m}-01`).format("MMMYY")
                    );
                    setCategories2(categories);
                    setLineChartAmountData(series);
                } else {
                    setCategories2([]);
                    setLineChartAmountData([]);
                }
            }
        } catch (error) {
            console.error("Error fetching Monthwise Total Bundle Cost:", error);
        }
    };


    const getLycaPercentageContributionData = async (body: any) => {
        try {
            const res = await getLycaPercentageContribution(body);

            if (res?.data?.statusCode === 200) {
                const response = res.data.response[0]; // since it's a single object

                if (response) {
                    // Extract series and labels
                    const labels = ["Voice Call Charges", "Data Charges", "Message Charges"];
                    const rawSeries = [
                        response.voice_charges || 0,
                        response.data_charges || 0,
                        response.message_charges || 0,
                    ];
                    const total = rawSeries.reduce((sum, val) => sum + val, 0);
                    const series = total > 0
                        ? rawSeries.map(val => Number(((val / total) * 100).toFixed(0))) // rounded %
                        : [0, 0, 0];
                    setDonutLabels(labels);
                    setDonutSeries(rawSeries);
                } else {
                    setDonutLabels([]);
                    setDonutSeries([0, 0, 0]);
                }
            }
        } catch (error) {
            console.error("Error fetching Percentage Contribution:", error);
        }
    };


    const getLycaDistributionRfmData = async (body: any) => {
        try {
            const res = await getLycaDistributionRfm(body);

            if (res?.data?.statusCode === 200) {
                let response: { RFM_Category: string; totalCount: number }[] =
                    res.data.response || [];

                if (response.length > 0) {
                    // 🔹 Move "Others" to the end
                    response = response.sort((a, b) => {
                        if (a.RFM_Category === "Others") return 1;
                        if (b.RFM_Category === "Others") return -1;
                        return 0;
                    });

                    // X-axis categories
                    const categories = response.map(item => item.RFM_Category);

                    // Y-axis values
                    const data = response.map(item => item.totalCount);

                    // Update chart state
                    setSeriesBundleData([
                        {
                            name: "Total Count",
                            data: data,
                        },
                    ]);
                    setCategoriesBundleData(categories);
                } else {
                    setSeriesBundleData([{ name: "Total Count", data: [] }]);
                    setCategoriesBundleData([]);
                }
            }
        } catch (error) {
            console.error("Error fetching Distribution RFM Data:", error);
            setSeriesBundleData([{ name: "Total Count", data: [] }]);
            setCategoriesBundleData([]);
        }
    };


    const getLycaCountEachChannelCategoryData = async (body: any) => {
        try {
            const res = await getLycaCountEachChannelCategory(body);

            if (res?.data?.statusCode === 200) {
                const response: { CHANNEL_CATEGORY: string; TotalCount: number }[] =
                    res.data.response || [];

                if (response.length > 0) {
                    // Categories (x-axis)
                    const categories = response.map(item => item.CHANNEL_CATEGORY);

                    // Series data (y-axis values)
                    const data = response.map(item => item.TotalCount);

                    // Update chart state
                    setSeriesBubleWeek([
                        {
                            name: "Total Count",
                            data: data,
                        },
                    ]);

                    setCategoriesBubleWeek(categories);
                } else {
                    setSeriesBubleWeek([{ name: "Total Count", data: [] }]);
                    setCategoriesBubleWeek([]);
                }
            }
        } catch (error) {
            console.error("Error fetching Channel Category Data:", error);
            setSeriesBubleWeek([{ name: "Total Count", data: [] }]);
            setCategoriesBubleWeek([]);
        }
    };

    const getLycaDistributionCvlSegementData = async (body: any) => {
        try {
            const res = await getLycaDistributionCvlSegement(body);

            if (res?.data?.statusCode !== 200) return;

            const response = res.data.response;

            // X-axis labels = CLV_Segment
            const categories = response.map((item: any) => item.CLV_Segment);

            // Y-axis values = totalCount
            const series = [
                {
                    name: "Number of Customers",
                    data: response.map((item: any) => item.totalCount),
                },
            ];

            // Update state
            setClvCategories(categories);
            setLineChartBundleHrs(series);
        } catch (error) {
            console.error("Error fetching CLV Segment distribution:", error);
        }
    };




    const getLycaDistributionNboSegementData = async (body: any) => {
        try {
            const res = await getLycaDistributionNboSegement(body);
            console.log("res======", res);

            if (res?.data?.statusCode !== 200) return;

            const response = res.data.response;

            // Categories = NBO_Segment (x-axis labels)
            const categories = response.map((item: any) => item.NBO_Segment);

            // Series = Number of Customers (y-axis values)
            const series = [
                {
                    name: "Number of Customers",
                    data: response.map((item: any) => item.totalCount),
                },
            ];

            console.log("categories---", categories);
            console.log("series---", series);

            // update states for chart
            setCategoriesNbo(categories);
            setSeriesNbo(series);
        } catch (error) {
            console.error("Error fetching NBO Segment distribution:", error);
        }
    };

    const getLycaTotalRevenuePerCustomerData = async (body: any) => {
        try {
            const res = await getLycaTotalRevenuePerCustomer(body);
            console.log("res======", res);

            if (res?.data?.statusCode !== 200) return;

            const response = res.data.response;

            // x-axis labels = cluster_name
            const categories = response.map((item: any) => item.cluster_name);

            // y-axis values = TotalRevenue
            const series = [
                {
                    name: "Total Revenue",
                    data: response.map((item: any) => item.TotalRevenue),
                },
            ];

            console.log("categories---", categories);
            console.log("series---", series);

            setCategoriesRevenue(categories);
            setSeriesRevenue(series);
        } catch (error) {
            console.error("Error fetching Total Revenue per Customer:", error);
        }
    };


    return (

        <>
            <div className={styles.mainframe}>
                {loader ? (
                    <Loaders />
                ) : (
                    <div className={styles.clvchartssec}>
                        <div className={`${styles.clvchartwrapper}`}>
                            <div className={styles.clvwrapheader}>
                                <p className={styles.clvwrapheadertxt}>User Count of each SIM type</p>
                                <span className={styles.clvwrpadesc}>See which SIM type has the larger user base and what drives it</span>
                            </div>
                            <div className={styles.clvwrapbody}>
                                <p className={styles.clvwrapcaptions}>x-axis <span>SIM Type</span>y-axis <span>Count</span></p>
                                <ApexBarChart
                                    isStacked={false}
                                    series={seriesbar}
                                    colors={["#575CFF"]}
                                    categories={categories}
                                />
                            </div>
                            <div className={styles.clvwrapfooter}>
                                <div className='insightsbtn'>AI Insights</div>
                                <p className={styles.clvwrapfttxt}>{clvNlpLycaData[0]?.summary}</p>
                                <span
                                    className={styles.seemoretxt}
                                    onClick={() => {
                                        setShowInsightsModal(true);
                                        dispatch(dashboardAction.setSummary(clvNlpLycaData[0]?.actual_summary))
                                    }
                                    }
                                    style={{ cursor: "pointer" }}
                                >
                                    See more
                                </span>

                            </div>
                        </div>
                        <div className={`${styles.clvchartwrapper} `}>
                            <div className={styles.clvwrapheader}>
                                <p className={styles.clvwrapheadertxt}>Total Revenue Cost of Sim type</p>
                                <span className={styles.clvwrpadesc}>See which SIM type drives the highest revenue and why.</span>
                            </div>
                            <div className={styles.clvwrapbody}>
                                <p className={styles.clvwrapcaptions}>x-axis <span>SIM Type</span>y-axis <span>Total Bundle Cost</span></p>
                                <ApexBarChart
                                    isStacked={false}
                                    series={seriesbarWeekDay}
                                    colors={["#00e4a2"]}
                                    categories={categoriesweekday}
                                    toastSuffix='Kr'
                                />
                            </div>
                            <div className={styles.clvwrapfooter}>
                                <div className='insightsbtn'>AI Insights</div>
                                <p className={styles.clvwrapfttxt}>{clvNlpLycaData[1]?.summary}</p>
                                <span
                                    className={styles.seemoretxt}
                                    onClick={() => {
                                        setShowInsightsModal(true);
                                        dispatch(dashboardAction.setSummary(clvNlpLycaData[1]?.actual_summary))
                                    }
                                    }
                                    style={{ cursor: "pointer" }}
                                >
                                    See more
                                </span>

                            </div>
                        </div>
                        <div className={`${styles.clvchartwrapper}`}>
                            <div className={styles.clvwrapheader}>
                                <p className={styles.clvwrapheadertxt}>Total Revenue per Recharge Type</p>
                                <span className={styles.clvwrpadesc}>Compare recharge types to see where customers spend most.</span>
                            </div>
                            <div className={styles.clvwrapbody}>
                                <p className={styles.clvwrapcaptions}>x-axis <span>Recharge Type</span>y-axis <span>Total Revenue</span></p>
                                <ApexBarChart
                                    isStacked={false}
                                    series={lineChartHourData}
                                    colors={["#00e4a2"]}
                                    categories={categories1}
                                    toastSuffix='Kr'
                                />

                            </div>
                            <div className={styles.clvwrapfooter}>
                                <div className='insightsbtn'>AI Insights</div>
                                <p className={styles.clvwrapfttxt}>{clvNlpLycaData[2]?.summary}</p>

                                <span
                                    className={styles.seemoretxt}
                                    onClick={() => {
                                        setShowInsightsModal(true);
                                        dispatch(dashboardAction.setSummary(clvNlpLycaData[2]?.actual_summary))
                                    }
                                    }
                                    style={{ cursor: "pointer" }}
                                >
                                    See more
                                </span>
                            </div>
                        </div>
                        <div className={`${styles.clvchartwrapper} `}>
                            <div className={styles.clvwrapheader}>
                                <p className={styles.clvwrapheadertxt}>Month-wise Total Actual Bundle Cost by SIM Type (Jan-Jun 2025)</p>
                                <span className={styles.clvwrpadesc}>Track which SIM type drove higher bundle costs and how trends shifted.</span>
                            </div>
                            <div className={styles.clvwrapbody}>
                                <p className={styles.clvwrapcaptions}>x-axis <span>Month</span>y-axis <span>Total Actual Bundle Cost</span></p>
                                <ApexLineChart
                                    series={lineChartAmountData}
                                    categories={categories2}
                                />
                            </div>
                            <div className={styles.clvwrapfooter}>
                                <div className='insightsbtn'>AI Insights</div>
                                <p className={styles.clvwrapfttxt}>{clvNlpLycaData[3]?.summary}</p>

                                <span
                                    className={styles.seemoretxt}
                                    onClick={() => {
                                        setShowInsightsModal(true);
                                        dispatch(dashboardAction.setSummary(clvNlpLycaData[3]?.actual_summary))
                                    }
                                    }
                                    style={{ cursor: "pointer" }}
                                >
                                    See more
                                </span>
                            </div>
                        </div>
                        <div className={`${styles.clvchartwrapper} `}>
                            <div className={styles.clvwrapheader}>
                                <p className={styles.clvwrapheadertxt}>Percentage Contribution of charges</p>
                                <span className={styles.clvwrpadesc}>Compare service types to uncover the highest cost contributor.</span>
                            </div>
                            <div className={styles.clvwrapbody} style={{ minHeight: '330px' }}>

                                <DonutChart
                                    key={JSON.stringify(donutSeries) + JSON.stringify(donutLabels)}
                                    series={donutSeries} labels={donutLabels}
                                    toastSuffix='%'
                                />

                                <div className={styles.labelsgrp}>
                                    {donutLabels.map((label, index) => {
                                        const colors = ["#438DBE", "#2CA02C", "#feb019"];
                                        return (
                                            <div key={index} className={styles.indvidualchartlabel}>
                                                <span
                                                    className={styles.dot}
                                                    style={{ backgroundColor: colors[index] }}
                                                ></span>
                                                <p>{label}</p>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                            <div className={styles.clvwrapfooter}>
                                <div className='insightsbtn'>AI Insights</div>
                                <p className={styles.clvwrapfttxt}>{clvNlpLycaData[4]?.summary}</p>

                                <span
                                    className={styles.seemoretxt}
                                    onClick={() => {
                                        setShowInsightsModal(true);
                                        dispatch(dashboardAction.setSummary(clvNlpLycaData[4]?.actual_summary))
                                    }
                                    }
                                    style={{ cursor: "pointer" }}
                                >
                                    See more
                                </span>
                            </div>
                        </div>
                        <div className={`${styles.clvchartwrapper}`}>
                            <div className={styles.clvwrapheader}>
                                <p className={styles.clvwrapheadertxt}>Count of each channel category</p>
                                <span className={styles.clvwrpadesc}>Discover which channels customers prefer the most.</span>
                            </div>
                            <div className={styles.clvwrapbody}>
                                <p className={styles.clvwrapcaptions}>x-axis <span>Channel Category</span>y-axis <span>Count</span></p>
                                <ApexBarChart
                                    isStacked={false}
                                    series={seriesBubleWeek}
                                    colors={["#575CFF"]}
                                    categories={categoriesBubleWeek}
                                />
                            </div>
                            <div className={styles.clvwrapfooter}>
                                <div className='insightsbtn'>AI Insights</div>
                                <p className={styles.clvwrapfttxt}>{clvNlpLycaData[5]?.summary}</p>

                                <span
                                    className={styles.seemoretxt}
                                    onClick={() => {
                                        setShowInsightsModal(true);
                                        dispatch(dashboardAction.setSummary(clvNlpLycaData[5]?.actual_summary))
                                    }
                                    }
                                    style={{ cursor: "pointer" }}
                                >
                                    See more
                                </span>
                            </div>
                        </div>
                        <div className={`${styles.clvchartwrapper} `}>
                            <div className={styles.clvwrapheader}>
                                <p className={styles.clvwrapheadertxt}>Distribution of RFM Categories</p>
                                <span className={styles.clvwrpadesc}>Discover which RFM segments drive retention and revenue focus.</span>
                            </div>
                            <div className={styles.clvwrapbody}>
                                <p className={styles.clvwrapcaptions}>x-axis <span>RFM Category</span>y-axis <span>Number of Customers</span></p>
                                <ApexBarChart
                                    isStacked={false}
                                    series={seriesbarBundleData}
                                    colors={['#439CF3']}
                                    categories={categoriesBundleData}
                                />
                            </div>
                            <div className={styles.clvwrapfooter}>
                                <div className='insightsbtn'>AI Insights</div>
                                <p className={styles.clvwrapfttxt}>{clvNlpLycaData[6]?.summary}</p>

                                <span
                                    className={styles.seemoretxt}
                                    onClick={() => {
                                        setShowInsightsModal(true);
                                        dispatch(dashboardAction.setSummary(clvNlpLycaData[6]?.actual_summary))
                                    }
                                    }
                                    style={{ cursor: "pointer" }}
                                >
                                    See more
                                </span>
                            </div>
                        </div>
                        <div className={`${styles.clvchartwrapper}`}>
                            <div className={styles.clvwrapheader}>
                                <p className={styles.clvwrapheadertxt}>Distribution of CLV Segments</p>
                                <span className={styles.clvwrpadesc}>Track customer distribution by lifetime value segments.</span>
                            </div>
                            <div className={styles.clvwrapbody}>
                                <p className={styles.clvwrapcaptions}>x-axis <span>CLV Segment</span>y-axis <span>Number of Customers</span></p>
                                <ApexBarChart
                                    isStacked={false}
                                    series={lineChartBundleHrs}   // [{ name: "2023", data: [...] }, { name: "2024", data: [...] }]
                                    colors={['#439CF3']}
                                    categories={clvCategories}   // ["0:00","1:00",..."23:00"]
                                />
                            </div>
                            <div className={styles.clvwrapfooter}>
                                <div className='insightsbtn'>AI Insights</div>
                                <p className={styles.clvwrapfttxt}>{clvNlpLycaData[7]?.summary}</p>

                                <span
                                    className={styles.seemoretxt}
                                    onClick={() => {
                                        setShowInsightsModal(true);
                                        dispatch(dashboardAction.setSummary(clvNlpLycaData[7]?.actual_summary))
                                    }
                                    }
                                    style={{ cursor: "pointer" }}
                                >
                                    See more
                                </span>
                            </div>
                        </div>
                        <div className={`${styles.clvchartwrapper}`}>
                            <div className={styles.clvwrapheader}>
                                <p className={styles.clvwrapheadertxt}>Distribution of NBO Segments</p>
                                <span className={styles.clvwrpadesc}>Compare segments to balance retention and revenue growth.</span>
                            </div>
                            <div className={styles.clvwrapbody}>
                                <p className={styles.clvwrapcaptions}>x-axis <span>Nbo Segment</span>y-axis <span>Number of Customers</span></p>
                                <ApexBarChart
                                    isStacked={false}
                                    series={seriesNbo}
                                    colors={["#7423D7"]}
                                    categories={categoriesNbo}
                                />
                            </div>
                            <div className={styles.clvwrapfooter}>
                                <div className='insightsbtn'>AI Insights</div>
                                <p className={styles.clvwrapfttxt}>{clvNlpLycaData[8]?.summary}</p>

                                <span
                                    className={styles.seemoretxt}
                                    onClick={() => {
                                        setShowInsightsModal(true);
                                        dispatch(dashboardAction.setSummary(clvNlpLycaData[8]?.actual_summary))
                                    }
                                    }
                                    style={{ cursor: "pointer" }}
                                >
                                    See more
                                </span>
                            </div>
                        </div>
                        <div className={`${styles.clvchartwrapper}`}>
                            <div className={styles.clvwrapheader}>
                                <p className={styles.clvwrapheadertxt}>Total Revenue per Customer Segment</p>
                                <span className={styles.clvwrpadesc}>Compare customer segments to identify where revenue is strongest.</span>
                            </div>
                            <div className={styles.clvwrapbody}>
                                <p className={styles.clvwrapcaptions}>x-axis <span>Customer Segment</span>y-axis <span>Total Revenue</span></p>
                                <ApexBarChart
                                    isStacked={false}
                                    series={seriesRevenue}
                                    colors={["#008FFB"]}
                                    categories={categoriesRevenue}
                                    toastSuffix='Kr'
                                />
                            </div>
                            <div className={styles.clvwrapfooter}>
                                <div className='insightsbtn'>AI Insights</div>
                                <p className={styles.clvwrapfttxt}>{clvNlpLycaData[9]?.summary}</p>

                                <span
                                    className={styles.seemoretxt}
                                    onClick={() => {
                                        setShowInsightsModal(true);
                                        dispatch(dashboardAction.setSummary(clvNlpLycaData[9]?.actual_summary))
                                    }
                                    }
                                    style={{ cursor: "pointer" }}
                                >
                                    See more
                                </span>
                            </div>
                        </div>

                    </div>

                )}


            </div>

            {/* Modal */}
            <WorktualModal
                show={showInsightsModal}
                // title="Insights"
                onClose={() => {
                    setShowInsightsModal(false)
                    dispatch(dashboardAction.setSummary({}))
                }
                } // assuming your modal accepts onClose
            >
                <div className={styles.insightsviewmdltext}>
                    <span className="insightsbtn" style={{ marginBottom: "12px" }}>
                        AI Insights
                    </span>
                    {
                        nlpSummary ? (
                            <p
                                className={styles.clvwrapfttxt}
                                dangerouslySetInnerHTML={{
                                    __html: nlpSummary
                                }}

                            />
                        ) : ("NO NLP DATA")
                    }
                </div>
            </WorktualModal>
        </>

    )
}

export default ClvAnalysisLyca
